import { graphql, useFragment } from "react-relay";
import { WorkspaceViewerFragment$key } from "./__generated__/WorkspaceViewerFragment.graphql";
import {
  MarimoIframe,
  MarimoIframeHandle,
  MarimoIframeProps,
} from "../MarimoIframe";
import { ComponentPropsWithoutRef, LegacyRef } from "react";
import { useReadyWorkspaceRunner } from "@/utils/workspace";
import WorkspacePhaseProgress from "../WorkspacePhaseProgress";

const Fragment = graphql`
  fragment WorkspaceViewerFragment on WorkspaceRunner {
    id
    phase
    url

    ...WorkspacePhaseProgressFragment
  }
`;

export interface WorkspaceViewerProps extends ComponentPropsWithoutRef<"iframe"> {
  iframeRef?: LegacyRef<MarimoIframeHandle> | undefined;
  workspace: WorkspaceViewerFragment$key;
  hideCode?: boolean | undefined;
  onStatusChanged?: MarimoIframeProps["onStatusChanged"];
}

export function WorkspaceViewer({
  iframeRef,
  workspace: workspaceFragment,
  hideCode = true,
  ...props
}: WorkspaceViewerProps) {
  const runner = useFragment(Fragment, workspaceFragment);
  const isReady = useReadyWorkspaceRunner(runner);
  if (!isReady) {
    if (props.hidden) return null;
    return (
      <div className="lg:w-[66%] m-auto">
        <WorkspacePhaseProgress workspace={runner} />
      </div>
    );
  }
  return (
    <MarimoIframe
      {...props}
      key={runner.url}
      ref={iframeRef}
      src={makeViewerShowCode(runner.url, hideCode)}
      autoResize
    />
  );
}

function makeViewerShowCode(viewerUrl: string, hideCode: boolean): string {
  const url = new URL(viewerUrl);
  if (hideCode) {
    url.searchParams.delete("show-code");
  } else {
    url.searchParams.set("show-code", "true");
  }
  return url.toString();
}
